<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card>
            <v-overlay v-model="overlay" 
                    color= "#FE5800" >
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            
            <v-card-title class="pa-0">
                <v-container style="" class="">

                    <v-row align="center" justify="center">

                        <v-col cols="12" sm="12" md="12">
                            
                                        
                            Edit Department
                                        
                                    
                        </v-col>
                                        

                    </v-row>

                </v-container>
            </v-card-title>

            <v-card-text>
                <v-divider></v-divider>
                <v-form v-model="valid" enctype="multipart/form-data" id="editdepartment">
                
            
                    <v-container>
                        <v-card elevation="3" class="pa-3 mb-3">

                            <v-row>
                                <v-col cols="12" md="12">
                                    <h4 class="title">Department Information</h4>
                                </v-col>
                            </v-row>

                            <v-row>
                        
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="data.departmentName"
                                        name="departmentName"
                                        label="Department Name"
                                        required
                                        v-validate="'required|max:100'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                    v-model="data.phone"
                                    name="phone"
                                    label="Department Phone"
                                    required
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.collect('phone')"
                                    data-vv-name="lastname"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                        
                                <v-col cols="12" md="12" sm="12">
                                    <v-text-field
                                        v-model="data.departmenttext"
                                        name="departmenttext"
                                        label="Department Text">
                                    </v-text-field>
                                </v-col>
                            </v-row>  

                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-autocomplete 
                                    label="Department Manager"
                                    v-model="data.employee_id"  
                                    name="employee_id"  
                                    item-text="name"
                                    item-value="id"  
                                    :items="employees"  
                                    v-validate="'required'"
                                    :error-messages="errors.collect('employees')"
                                    data-vv-name="businessType"></v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="12">
                                    <v-textarea
                                    v-model="data.description"
                                    name="description"
                                    label="Description"
                                    ></v-textarea>  
                                </v-col>
                                
                            </v-row>    

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <h3 class="title red--text">Select Image</h3>
                                </v-col>
                            </v-row>
                            <v-row>    
                                <v-col cols="12" md="6" sm="6">
                                
                                    <Cropper
                                        classname="cropper"
                                        :src="uploadedimage"
                                        @change="onChange"
                                    
                                    />
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12" align="center">
                                            <v-btn color="primary" @click="$refs.file.click()"> 
                                                
                                            <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="itemimage"/> Upload Image
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col col="12" md="6" sm="6">
                                    <img style="max-width:100%"  :src="image"    
                                        class="grey lighten-2"  max-height="300"  v-if="image!=null" />
                                </v-col>
                            </v-row>  

                        </v-card>

                        <v-divider></v-divider>
                        <div class="my-3">
                        <v-btn color="primary" @click="submit">Save</v-btn>
                        </div>  


                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>

</template>
<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";
    import { Cropper } from 'vue-advanced-cropper'
    import Editor from '@tinymce/tinymce-vue'


    Vue.use(VeeValidate);
    export default
    {

        props: 
        {
            source: String
        },
        data: () => 
        ({

            id:0,
            overlay:false,
            valid:true,
            counter: 0,
            departmentName:'',
            phone:'',
            departmentmanager:'',
            description:'', 
            employees: [],
            
            business_id:0,
            
            uploadedimage:null,
            image:null,
            coordinates: {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0
                },
            data:[], 

        }),
        created() 
        {
            if (this.$route.params.id) {
            this.id = this.$route.params.id;
            }
            this.fetchdata();
        },

        methods: 
        {

            fetchdata() 
            {
                this.overelay=true;

                this.$http
                .get(this.$apidomain+"departmentData/" + this.id)
                .then(res => 
                {
                    this.data=res.data.department;
                    this.image=this.data.image;
                    this.business_id=res.data.department.businesses_id;


                    this.$http
                    .get(this.$apidomain+"employeeList/"+ this.business_id)
                    .then(res => {
                        this.employees = res.data.employees;
                        //console.log("types "+ this.types);

                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                    
                    this.overelay=false;

                    console.log(res.data.department.businesses_id);
                })
                .catch(err => 
                {
                    console.log(err.response);
                    this.overelay=false;

                });
            },

            onChange({coordinates, canvas}) 
            {
            
                this.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image
                this.image = canvas.toDataURL()
            },
            uploadImage(event) {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                        // create a new FileReader to read this image and convert to base64 format
                        var reader = new FileReader();
                        // Define a callback function to run, when FileReader finishes its job
                        reader.onload = (e) => {
                                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                                // Read image as base64 and set to imageData
                                this.uploadedimage = e.target.result;
                        }
                        // Start the reader job - read file as a data url (base64 format)
                        reader.readAsDataURL(input.files[0]);
                }
            },
            
            dataURLtoFile(dataurl, filename) 
            {
    
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), 
                    n = bstr.length, 
                    u8arr = new Uint8Array(n);
                    
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
            
                return new File([u8arr], filename, {type:mime});
            },
            submit()
            {
                let th = this;
                if (this.$validator.validateAll()) {
                    let fd = new FormData(document.getElementById("editdepartment"));
                    fd.append('businesses_id',this.business_id);
                    fd.append('employee_id',this.data.employee_id);
                    if(this.uploadedimage!=null){
                    fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));    
                    }
                    this.$http
                    .post(this.$apidomain+"departmentupdate/"+this.id, fd)
                    .then(res => {
                        if(res.data.success)  
                        {
                        
                        
                            this.$router.push({name:'departmentlists'});
                            
                        }  
                        else
                        {
                            let errmsg=[];
                            for(var prop in res.data.errors){
                                errmsg.push(res.data.errors[prop][0]);
                            }
                            alert(errmsg[0]);
                        }
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            }

        }
        
    }
</script>